import comp from "./CourseFeedSkeletonLoader";
export default comp;
